<div class="ccm_usage">
    <div class="ccm_usage_left full_width">
        <h4>Family History</h4>
        <p [innerHTML]="dataInsight?.family_text | safeHtml"></p>
        <div class="canvas">
            <div class="canva_first">
                <canvas id="familyHistoryDoughnutChart" height="250" width="200"></canvas>
                <ul>
                    <li>Participants reported having a family history/connection to T1D.</li>
                    <li>Participants reported having no family history/connection to T1D.</li>
                </ul>
            </div>
            <div class="canva_sect">
                <canvas id="familyHistoryBarChart" height="400" width="650"></canvas>
            </div>

        </div>

    </div>

</div>